import Link from "next/link";
import { twMerge } from "tailwind-merge";

const LinkItem = ({ href, label, className }) => {
  return (
    <Link href={href}>
      <a className={twMerge("m-0 opacity-100", className)}>{label}</a>
    </Link>
  );
};

export default LinkItem;
